import React from 'react';
import { components } from 'react-select';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { useDroppableValueContainerService } from 'client/js/common/components/core/PureQueryBuilder/DraggableCompareBy/hooks';
import type { IndexedOption, ValueContainerProps } from 'client/libraries/branch-neo-next/OrderedSelectDropdown/types';

const DroppableValueContainer = (props: ValueContainerProps<IndexedOption>) => {
  const { css, onDragEnd } = useDroppableValueContainerService(props);

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable" direction="horizontal">
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps} className={css.container}>
            <components.ValueContainer {...props}>{props.children}</components.ValueContainer>
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default DroppableValueContainer;
